<template>
  <div class="contact">
    <div class="contact__content">
      <SectionHeader>Contact</SectionHeader>
      <div class="contact__wrapper">
        <div 
          class="contact__agent-wrapper josh-js"
          data-josh-anim-name="fadeIn"
          data-josh-duration="1500ms"
        >
          <ContactAgent 
            v-if="getAgent"
            :data="getAgent"
          />
          <ContactAgent :data="agent" v-for="agent in getMultiAgents" :key="agent.id" />
        </div>
        <div 
          class="contact__form-wrapper josh-js"
          data-josh-anim-name="fadeInRight"
          data-josh-duration="1500ms"
        >
          <ContactForm />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import Josh from 'joshjs';

  import SectionHeader from '../../components/SectionHeader';
  import ContactAgent from './components/ContactAgent';
  import ContactForm from './components/ContactForm';

  export default {
    name: 'Contact',
    components: {
      SectionHeader,
      ContactAgent,
      ContactForm
    },
    computed: {
      ...mapGetters('tour', ['getAgent', 'getMultiAgents'])
    },
    mounted () {
      // eslint-disable-next-line
      const josh = new Josh();
    }
  };
</script>

<style lang="scss">
  @import '../../styles/mixins.scss';

  .contact {
    background-color: var(--primary-section-color);

    &__content {
      @include layoutContent();
      @include layoutHPadding();
      @include layoutVPadding();
    }

    &__wrapper {
      display: flex;
      flex-wrap: wrap;
    }

    &__agent-wrapper {
      width: 100%;

      @include lgScreen() {
        width: 320px;
        margin: 0 40px 80px 0;
      }
    }

    &__form-wrapper {
      width: 100%;
      margin-top: 30px;

      @include lgScreen() {
        width: calc(100% - 320px - 40px);
        margin-top: 0;
      }
    }
  }
</style>
